import { createSelector } from 'reselect';
import { VehicleConfigurationAttributesType } from '../enums';
const getVehicleConfigurationAttributesSource = (state) => state.domain.vehicleConfigurationAttributes;
export const getVehicleConfigurationAttributesByType = createSelector([
    getVehicleConfigurationAttributesSource,
    (state, attributesType) => attributesType
], (vehicleAttribute, attributesType) => {
    var _a;
    return attributesType && ((_a = vehicleAttribute[attributesType]) === null || _a === void 0 ? void 0 : _a.allIds.length) > 0
        ? vehicleAttribute[attributesType].allIds.map(id => vehicleAttribute[attributesType].byId[id])
        : [];
});
export const getInProgressStatus = (state) => (state.domain.vehicleConfigurationAttributes && state.domain.vehicleConfigurationAttributes.isInProgress) || false;
/**
 * Returns true if vehicle has any attributes available to select
 * @param state Current vehicle configuration attribute domain state
 */
export const getHasVehicleAttributes = (state) => {
    const hasNadaAttributes = getVehicleConfigurationAttributesByType(state, VehicleConfigurationAttributesType.NADA_ATTRIBUTES).length;
    const hasPinAttributes = getVehicleConfigurationAttributesByType(state, VehicleConfigurationAttributesType.PIN_ATTRIBUTES).length;
    const hasRedbookAttributes = getVehicleConfigurationAttributesByType(state, VehicleConfigurationAttributesType.REDBOOK_ATTRIBUTES).length;
    return !!hasNadaAttributes || !!hasPinAttributes || !!hasRedbookAttributes;
};
//# sourceMappingURL=selectors.js.map